import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerDto } from '../dtos/customer.dto';
import { environment } from '../../../../environments/environment';
import { MemoryService } from '../../../core/services/memory.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(private http: HttpClient, private customerIdService: MemoryService) {
  }

  lookupCustomerId(customerKey: string): Observable<{customerId: number}> {
    return this.http.get<{customerId: number}>(`${environment.cenplexBookingApiBaseUrl}/customer-id/${customerKey}`);
  }

  getCustomer(): Observable<CustomerDto> {
    return this.http.get<CustomerDto>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.customerIdService.customerId}`);
  }

  updateCustomer(customerDto: CustomerDto): Observable<void> {
    return this.http.put<void>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.customerIdService.customerId}`, customerDto);
  }
}
